export default "__VITE_ASSET__CxVEH6lV__"